import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { ShieldAlert, ChevronRight } from "lucide-react";

const MORE = { de: "Mehr erfahren", en: "Learn more", it: "Scopri di più", tr: "Daha fazla", ru: "Подробнее", es: "Más info", fr: "En savoir plus", pl: "Więcej", sr: "Сазнај више", hr: "Saznaj više", sq: "Mëso më shumë", sl: "Več", pt: "Saber mais", cs: "Více", hu: "Tovább", hi: "और जानें", ms: "Ketahui lagi", nl: "Meer info", zh: "了解更多" };

// Eye-catching scrolling notice; click opens the Links page (VPN tools etc.).
export function WelcomeNotice({ lang, onNavigate, className = "" }) {
  const [text, setText] = useState("");
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/welcome-notice`, { params: { lang } }).then((r) => alive && setText(r.data.enabled ? r.data.text : "")).catch(() => {});
    return () => { alive = false; };
  }, [lang]);
  if (!text) return null;
  const go = () => onNavigate && onNavigate("links");
  const item = (
    <span className="inline-flex items-center gap-2 pr-16 whitespace-nowrap">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="font-semibold">{text}</span>
      <span className="inline-flex items-center gap-0.5 underline underline-offset-2 opacity-90">{MORE[lang] || MORE.en}<ChevronRight className="h-3.5 w-3.5" /></span>
    </span>
  );

  return (
    <button type="button" onClick={go} data-testid="welcome-notice-ticker" title={text}
      className={`group relative w-full min-w-0 overflow-hidden rounded-full border border-amber-500/60 bg-gradient-to-r from-amber-400 to-orange-500 text-[#3B1D00] shadow-md shadow-amber-500/25 text-left text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-600 ${className}`}>
      <span className="absolute left-0 top-0 bottom-0 z-10 flex items-center pl-4 pr-3 bg-[#3B1D00] text-amber-300 text-[10px] font-bold uppercase tracking-widest">
        <span className="h-2 w-2 rounded-full bg-amber-300 mr-1.5 animate-ping" />!
      </span>
      <span className="block py-2 sm:py-2.5 pl-12">
        <span className="ticker-track inline-flex group-hover:[animation-play-state:paused] group-focus-visible:[animation-play-state:paused]" data-testid="welcome-notice-text">
          {item}{item}
        </span>
      </span>
    </button>
  );
}
